module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"protrusion-formula":{"DEFAULT":"Saillie le","FIRST":"Saillie pour la première fois le","AVORTED":"A avorté","SANK":"A coulé","EMPTY":"Vide","NONE":"Non saillie"}}}')
  delete Component.options._Ctor
}
